import { Component, OnInit, ViewChild, ChangeDetectorRef, Injector } from '@angular/core';
import { FilterAthletePhotosServiceService } from '../../services/filter-athlete-photos-service.service';
import { Observable, combineLatest } from 'rxjs';
import { IPhotos } from 'src/app/common-page-components/stores/entities-store/athlete-photos-store';
import { NgbSlideEvent } from '@ng-bootstrap/ng-bootstrap/carousel/carousel';
import { NgbCarousel } from '@ng-bootstrap/ng-bootstrap';
import { TeamEntriesStore, ITeamEntries } from '../../../../common-page-components/stores/entities-store/team-entries-store';
import { HttpClient } from '@angular/common/http';
import { filter, tap, mergeMap, distinctUntilChanged, debounceTime, withLatestFrom } from 'rxjs/operators';
import { BaseComponentComponent } from '../../../../library/components/components/common/base-component/base-component.component';
import { IPhotosCompetition } from '../../../../common-page-components/stores/entities-store/athlete-photos-store';
import { Router } from '@angular/router';

@Component({
  selector: 'app-bootstrap-athlete-photos',
  templateUrl: './bootstrap-athlete-photos.component.html',
  styleUrls: ['./bootstrap-athlete-photos.component.scss']
})
export class BootstrapAthletePhotosComponent extends BaseComponentComponent implements OnInit {

  /**
   * View of caroulse component for set active Id.
   *
   * @type {NgbCarousel}
   * @memberof BootstrapAthletePhotosComponent
   */
  @ViewChild(NgbCarousel, { static: false }) carousel: NgbCarousel;

  /**
   * Photo view child for get the width.
   *
   * @memberof BootstrapAthletePhotosComponent
   */
  @ViewChild("photo", { static: false }) photo;

  /**
   * A string fot set the ng style of photos.
   *
   * @memberof BootstrapAthletePhotosComponent
   */
  viewPhotoClass = '';

  /**
   * A variable for display or hide the events information column and avoid flip the style.
   *
   * @memberof BootstrapAthletePhotosComponent
   */
  ready = false;

  /**
   * Photo selected id for open the carousel.
   *
   * @type {string}
   * @memberof BootstrapAthletePhotosComponent
   */
  photo_selected: string;

  /**
   * A variable for set the last params available and remember the query of filters on load more data.
   *
   * @memberof BootstrapAthletePhotosComponent
   */
  last_params = {};


  constructor(
    public photos_service: FilterAthletePhotosServiceService,
    public change_detector: ChangeDetectorRef,
    private http: HttpClient,
    private injector: Injector) {
    super()
  }

  /**
   * {@inheritdoc}
   *
   * @memberof BootstrapAthletePhotosComponent
   */
  ngOnInit() {
    this.subscriptions.push(
      combineLatest(
        this.photos_service.eventsCombo.comboData.pipe(tap(a=>{
          this.last_params['competition_id'] = a.id;
        })),
        this.photos_service.rangeDate.comboData.pipe()

      ).pipe(
        tap((filters) => {
          const comboData = filters[0];
          const rangeData = filters[1];
          const params = {
            'date_from': rangeData.date_from ? rangeData.date_from.toISOString() : undefined,
            'date_to': rangeData.date_to ? rangeData.date_to.toISOString() : undefined,
            'competition_id': comboData.id
          };
          this.last_params['date_from'] = params.date_from;
          this.last_params['date_to'] = params.date_to;
          this.photos_service.athletePhotoStore.requestData(params, false).subscribe();
        })
      )

        .subscribe());
  }

  /**
   * Observable of photos.
   *
   * @readonly
   * @type {Observable<IPhotos>}
   * @memberof BootstrapAthletePhotosComponent
   */
  get data(): Observable<IPhotos> {
    return this.photos_service.athletePhotoStore.dataStream.pipe(filter(value => value != undefined));
  }

  /**
   * The getter for team entries.
   *
   * @readonly
   * @type {Observable<ITeamEntries>}
   * @memberof BootstrapAthletePhotosComponent
   */
  get dataAthleteDetail(): Observable<ITeamEntries> {
    return this.photos_service.photo_team_entries.dataStream.pipe(filter(value => value != undefined));
  }

  /**
   * Method for select the photo.
   *
   * @param {string} id the photo id. (usually URL)
   * @param {string} compId the competition id for search in the api.
   * @memberof BootstrapAthletePhotosComponent
   */
  selectPhoto(id: string, compId?: string) {
    this.photo_selected = id.toString();
    if (compId) {
      // Call service to obtain team entries.
      this.photos_service.loadAthletesEntries(compId).subscribe();

    }
  }

  /**
   * A method to close the video modal.
   *
   * @memberof BootstrapAthleteVideosComponent
   */
  closePhoto() {
    this.photo_selected = null;
    // Call service to clear team entries.
    this.photos_service.loadAthletesEntries(undefined).subscribe(next => this.change_detector.detectChanges());

  }

  /**
   * A method for loadmore data.
   *
   * @memberof BootstrapAthletePhotosComponent
   */
  loadMore() {
    this.photos_service.loadMore(this.last_params);
  }

  /**
   * Get observable of the athletes photos endpoint.
   */
  getPhotosObservable() {
    return this.photos_service.athletePhotoStore.requestData(this.last_params, true);
  }

  /**
   * A method for limit the name of event and avoid overflow.
   *
   * @param {string} eventName the event name.
   * @returns
   * @memberof BootstrapAthletePhotosComponent
   */
  limitNameOfEvent(eventName: string) {
    return eventName.length > 40 ? eventName.slice(0, 38) + '...' : eventName;
  }

  /**
   * Method for obtain the url of photo with more quality.
   *
   * @param {string} url
   * @returns
   * @memberof BootstrapAthletePhotosComponent
   */
  originalPhotoUrl(url: string, i: number) {
    /* setTimeout(()=>{
       //  console.log("PHOTO", this.carousel.slides.toArray()[i].tplRef.elementRef, i);
     }, 1000)*/
    return url.replace('/M/', '/O/');
  }

  /**
   * A method for load more photos from carousel.
   *
   * @param {NgbSlideEvent} event
   * @memberof BootstrapAthletePhotosComponent
   */
  loadMorePhotosFromCarousel(event: NgbSlideEvent) {
    this.ready = false;
    const index = this.photos_service.athletePhotoStore.data.findIndex(photo => event.current === photo.urls[0].median);
    const totalElements = this.photos_service.athletePhotoStore.data.length;
    if ((totalElements - 10 <= index) && this.photos_service.areMoreData()) {
      // Preload more photos when navigating in the last 10 photos.
      this.loadMore();

    }
    else if (index === 0 && this.photos_service.areMoreData()) {
      // This is the case when user slide to next photo, and it's position is the last one.
      this.change_detector.detach();
      this.getPhotosObservable().pipe(mergeMap(a => {
        const nextPhotoIndex = totalElements;
        const activeId: IPhotos = this.photos_service.athletePhotoStore.data[nextPhotoIndex];
        this.carousel.activeId = activeId.urls[0].median;
        return this.photos_service.loadAthletesEntries(
          activeId.competitions && activeId.competitions[0] ? activeId.competitions[0].id : undefined
        )
      })).subscribe((data) => {
        this.change_detector.reattach();
      });
      return;
    }
    const activePhoto = this.photos_service.athletePhotoStore.data[index];
    this.photos_service.loadAthletesEntries(
      activePhoto.competitions && activePhoto.competitions[0] ? activePhoto.competitions[0].id : undefined
    ).subscribe();
  }

  /**
   * Method for calcualte the load size of image.
   *
   * @param {*} event
   * @memberof BootstrapAthletePhotosComponent
   */
  onLoad(event) {
    const path = event.composedPath();
    if (path[0].naturalHeight > path[0].naturalWidth) {
      this.viewPhotoClass = '483px';
    } else {
      this.viewPhotoClass = '100%';
    }
    this.ready = true;

  }

}
